"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketsHolder = (function () {
    function TicketsHolder() {
        this.tickets = [];
    }
    TicketsHolder.prototype.clearTickets = function () {
        this.tickets = [];
        var holderDiv = document.getElementById('ticketsScroll');
        if (holderDiv !== null) {
            holderDiv.innerHTML = '';
            holderDiv.innerHTML = '<div id="winningDelimiter"></div>';
        }
    };
    TicketsHolder.prototype.addTicket = function (ticket) {
        this.tickets.push(ticket);
    };
    TicketsHolder.prototype.showTickets = function () {
        var self = this;
        for (var key in this.tickets) {
            $("#ticketsScroll").append(this.tickets[key].getHTML(Number(key)));
        }
        $('.ticket-share-image').on('click', function () {
            $('#ticket-share-confirm' + this.dataset.sharekey).css('display', 'flex');
        });
        $('.shareConfirmNo').on('click', function () {
            $('#ticket-share-confirm' + this.dataset.sharekey).css('display', 'none');
        });
        setTimeout(function () {
            var ticketsEvent = new CustomEvent('tickets-present');
            window.dispatchEvent(ticketsEvent);
        }, 250);
        $('.shareConfirmYes').on('click', function () {
            var tempKey = this.dataset.sharekey;
            $('#ticket-share-confirm' + tempKey).css('display', 'none');
            var ticketEvent = new CustomEvent('getTicket', {
                bubbles: true,
                detail: {
                    winStatus: self.tickets[(Number(tempKey))].getWinStatus(),
                    drawnNumbers: self.tickets[(Number(tempKey))].getDrawnNumbers(),
                    ticketId: self.tickets[(Number(tempKey))].ticketID,
                    sharedData: self.tickets[Number(tempKey)].getSharedWinsData(),
                    ticketHTML: self.tickets[Number(tempKey)].shareHTML()
                }
            });
            window.dispatchEvent(ticketEvent);
        });
    };
    TicketsHolder.prototype.updateTickets = function () {
        for (var key in this.tickets) {
            this.tickets[key].update();
        }
    };
    TicketsHolder.prototype.markWinningTicket = function (ticketID) {
        $('#ticket-' + ticketID).addClass('winning-ticket');
        $('#shareButton-' + ticketID).addClass('showShare');
        $('#winningDelimiter').append($('#ticket-' + ticketID));
    };
    return TicketsHolder;
}());
exports.default = TicketsHolder;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/tickets-holder.ts
// module id = 1170
// module chunks = 2